import { Report } from './report';
import { ReportHistoryMetadata } from './report-history-metadata';

export class ReportHistory extends Report {
  public reportFileId: number;
  public resultFileName: string;
  public createdAt: string;
  public serializedReportParameters: {[key: string]: any};
  constructor(
    private _metadata: ReportHistoryMetadata
  ) {
    super(_metadata.reportGeneratorCode);
    this.reportFileId = _metadata.reportFileId;
    this.resultFileName = _metadata.resultFileName;
    this.createdAt = _metadata.createdAt;
    this.serializedReportParameters = _metadata.serializedReportParameters;
  }
}
